import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import globalText from "../../../../utils/globalText";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";

const ScheduleBeneficiaryTransactionFailed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { schedulesTxnCreateError } = useSelector(
    (state) => state.schedulesTxn,
  );

  const extractErrorMessages = (errors) => {
    const messages = [];

    const recurse = (value) => {
      if (Array.isArray(value)) value.forEach(recurse);
      else if (typeof value === "object" && value !== null)
        Object.values(value).forEach(recurse);
      else if (typeof value === "string") messages.push(value);
    };

    recurse(errors);
    return messages;
  };

  const errorMessages = schedulesTxnCreateError
    ? extractErrorMessages(schedulesTxnCreateError)
    : [];

  const buttonRows = [
    [
      {
        btnText: `Create new schedule`,
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON,
        imgColor: "var(--negative-bg)",
        handleFunction: () =>
          navigate("/beneficiary_transaction_dashboard/create_schedule"),
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: `${globalText?.GO_TO} ${globalText?.DASHBOARD}`,
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/beneficiary_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    dispatch(disableSwitcher());
  }, [dispatch]);

  return (
    <>
      <StatusContainer
        status="error"
        title={globalText?.SCHEDULE_CREATION_FAILED}
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Error details">
          <>
            {errorMessages.map((msg, index) => (
              <InfoCard
                key={index}
                bgColor="var(--negative-card)"
                rows={[
                  {
                    leftTitle: msg,
                    leftSubTitle: "Error message",
                  },
                ]}
              />
            ))}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default ScheduleBeneficiaryTransactionFailed;
